export function triggerLightHaptic() {
  if (typeof navigator === "undefined" || typeof navigator.vibrate !== "function") {
    return;
  }

  try {
    navigator.vibrate(8);
  } catch {
    // Unsupported browser policies should not affect the quantity interaction.
  }
}